








import { Result } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import EventButton from '../event-button.vue';

@Component({
  components: {
    EventButton
  }
})
export default class ResultAddToCartButton extends Vue {
  @Prop({ required: true })
  item: Result;

  buttonEvent = EVENTS.Add2CartOnResultClicked;
}
